import SEO from "../components/SEO";

export default function Bio() {
  return (
    <>
      <SEO
        title="Bio"
        description="Nathan Portelli (b. 1988) is a visual artist from Gozo, Malta. He holds a degree in History of Art and works primarily with cement to explore cultural identity and landscape challenges."
        url="https://nathanportelli.com"
      />
      <div className="mt-10 ml-5 w-full flex flex-col animate-fadeInUp max-md:ml-0 max-md:w-full max-md:overflow-x-hidden">
        <h2 className="text-xl font-normal m-0 mb-8 tracking-wide">Bio</h2>
        <p className="text-base leading-relaxed mb-10 text-gray-800 max-w-2xl">
          Nathan Portelli (b. 1988) is a visual artist from Gozo. He holds a
          degree in History of Art from the Department of Art and Art History at
          the University of Malta.
        </p>
        <p className="text-base leading-relaxed mb-10 text-gray-800 max-w-2xl">
          Portelli’s work is deeply rooted in his connection to his homeland and
          his concern for humanity’s impact on it. Working predominantly with
          cement, he addresses the ongoing challenges to Malta’s cultural and
          natural landscapes—challenges shaped by a society where economic
          profit, greed, and corruption often overshadow shared values. Through
          the very material that continues to dominate and reshape his
          environment, he examines both its possibilities and limitations as an
          artistic medium.
        </p>
        <p className="text-base leading-relaxed mb-10 text-gray-800 max-w-2xl">
          More recently, his practice has embraced spiritual and esoteric
          dimensions, drawing on symbolism, inner states, and metaphysical
          threads that intersect with his continuing explorations of place,
          identity, and transformation.
        </p>
        <p className="text-base leading-relaxed mb-10 text-gray-800 max-w-2xl">
          Portelli lives in Gozo and works between Malta and London.
        </p>

        <div className="mt-4 max-w-96">
          <img
            src="/images/nathan-portelli-bio.jpg"
            alt="Nathan Portelli"
            className="w-full h-auto block"
          />
        </div>
      </div>
    </>
  );
}
